import { Components, Theme } from '@mui/material';
import {
  LELY_TOOLTIP_ARROW_FONT_SIZE,
  getLelyTooltipSurfaceStyles,
} from '../lelyTooltipSurfaceStyles';

export const getTooltipComponents = (
  theme: Theme,
): Pick<Components<Theme>, 'MuiTooltip'> => ({
  MuiTooltip: {
    defaultProps: {
      arrow: true,
      placement: 'top',
      TransitionProps: {
        timeout: 0,
      },
    },

    styleOverrides: {
      tooltip: {
        ...getLelyTooltipSurfaceStyles(theme),
        maxWidth: 200,
        textAlign: 'center',
        transition: 'none',
      },

      arrow: {
        color: theme.palette.background.information,
        fontSize: LELY_TOOLTIP_ARROW_FONT_SIZE,
      },

      popper: {
        '& .MuiGrow-root': {
          transition: 'none',
          transform: 'none',
          opacity: 1,
        },
      },
    },
  },
});
